/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Preset_Manager_Import_Success_ToastInputs */

const en_preset_manager_import_success_toast = /** @type {(inputs: Preset_Manager_Import_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} preset(s) imported successfully`)
};

const fr_preset_manager_import_success_toast = /** @type {(inputs: Preset_Manager_Import_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} preset(s) importe(s) avec succes`)
};

const de_preset_manager_import_success_toast = /** @type {(inputs: Preset_Manager_Import_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}-Voreinstellung(en) erfolgreich importiert`)
};

const it_preset_manager_import_success_toast = /** @type {(inputs: Preset_Manager_Import_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} preset importati correttamente`)
};

const ru_preset_manager_import_success_toast = /** @type {(inputs: Preset_Manager_Import_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Предустановки ${i?.count} успешно импортированы.`)
};

const es_preset_manager_import_success_toast = /** @type {(inputs: Preset_Manager_Import_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ajustes preestablecidos importados exitosamente`)
};

const zh_cn2_preset_manager_import_success_toast = /** @type {(inputs: Preset_Manager_Import_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已成功导入 ${i?.count} 预设`)
};

const ja_preset_manager_import_success_toast = /** @type {(inputs: Preset_Manager_Import_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} プリセットが正常にインポートされました`)
};

const hi_preset_manager_import_success_toast = /** @type {(inputs: Preset_Manager_Import_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} प्रीसेट सफलतापूर्वक आयात किए गए`)
};

const pt_pt2_preset_manager_import_success_toast = /** @type {(inputs: Preset_Manager_Import_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Predefinições ${i?.count} importadas com sucesso`)
};

/**
* | output |
* | --- |
* | "{count} preset(s) imported successfully" |
*
* @param {Preset_Manager_Import_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_import_success_toast = /** @type {((inputs: Preset_Manager_Import_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Import_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_preset_manager_import_success_toast(inputs)
	if (locale === "de") return de_preset_manager_import_success_toast(inputs)
	if (locale === "it") return it_preset_manager_import_success_toast(inputs)
	if (locale === "ru") return ru_preset_manager_import_success_toast(inputs)
	if (locale === "es") return es_preset_manager_import_success_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_preset_manager_import_success_toast(inputs)
	if (locale === "ja") return ja_preset_manager_import_success_toast(inputs)
	if (locale === "hi") return hi_preset_manager_import_success_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_preset_manager_import_success_toast(inputs)
	return en_preset_manager_import_success_toast(inputs)
});